import { render, staticRenderFns } from "./roleAuthorization.vue?vue&type=template&id=2a316066&scoped=true"
import script from "./roleAuthorization.vue?vue&type=script&lang=js"
export * from "./roleAuthorization.vue?vue&type=script&lang=js"
import style0 from "./roleAuthorization.vue?vue&type=style&index=0&id=2a316066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a316066",
  null
  
)

export default component.exports